import { initializeApp } from "firebase/app"
import { initializeAuth, browserLocalPersistence, browserPopupRedirectResolver } from "firebase/auth"
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check"
//import { getAnalytics } from "firebase/analytics"

// DEV
/*const firebaseConfig = {
  apiKey: "AIzaSyByh2I1r0OTHuaKKnTfbjp87pPveynBJxE",
  authDomain: "voltie-dev.firebaseapp.com",
  databaseURL: "https://voltie-dev-default-rtdb.firebaseio.com",
  projectId: "voltie-dev",
  storageBucket: "voltie-dev.appspot.com",
  messagingSenderId: "402186632915",
  appId: "1:402186632915:web:c9ca208d2a0f0fbfddde26",
  measurementId: "G-28BC52YC0M"
}*/

// PROD
const firebaseConfig = {
  apiKey: "AIzaSyBtNQhnIcWxr9ny4pklYxkXYKTl-RlO8_M",
  authDomain: "voltie-charger.firebaseapp.com",
  databaseURL: "https://voltie-charger-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "voltie-charger",
  storageBucket: "voltie-charger.appspot.com",
  messagingSenderId: "130173012234",
  appId: "1:130173012234:web:834e34c16349dbc0dd52f3",
  measurementId: "G-FP0Q1FY5VN"
}

const fbConf = initializeApp(firebaseConfig)

// Firebase App Check (VLT-2259): attaches an invisible reCAPTCHA v3 attestation token to every
// Firebase request (RTDB/Auth), so Firebase can reject traffic that isn't our genuine web app.
// The frontend writes directly to broad RTDB paths from the browser, and the Firebase config ships
// publicly in the bundle, so this closes off scripted access using a copied config.
// No user-facing challenge; reCAPTCHA v3 runs silently. Guarded on the site-key env var, so until
// VITE_RECAPTCHA_SITE_KEY is set the app behaves exactly as before (safe to ship pre-rollout).
const appCheckSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY
if (appCheckSiteKey) {
  // On localhost/CI, register a debug token (printed to the console on first load) in the Firebase
  // App Check console so development traffic passes without a real reCAPTCHA attestation.
  if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
    (self as unknown as { FIREBASE_APPCHECK_DEBUG_TOKEN?: boolean }).FIREBASE_APPCHECK_DEBUG_TOKEN = true
  }
  initializeAppCheck(fbConf, {
    provider: new ReCaptchaV3Provider(appCheckSiteKey),
    isTokenAutoRefreshEnabled: true,
  })
}

// Initialize auth once with localStorage persistence to avoid repeated IndexedDB writes
// This prevents Safari from hanging when many tabs are open (known Firebase bug)
// initializeAuth skips the defaults getAuth would install, so the popup resolver has to be named
// explicitly - without it every signInWithPopup throws auth/argument-error (VLT-2669).
initializeAuth(fbConf, { persistence: browserLocalPersistence, popupRedirectResolver: browserPopupRedirectResolver })

// Only activate this after the cookie policy and prompt are visible on the site
//getAnalytics(fbConf)
export default fbConf
